import $ from "jquery";
// import Swiper bundle with all modules installed
// import Swiper, { Navigation, Pagination } from 'swiper';
import "slick-carousel";

const slider = () => {
  const el = {
    tabContent: "details.js-ListContent ",
    button: ".SpecificationSection .js-BtnListContent",
  };

  if ($(el.tabContent).length === 0) return;

  $(() => {
    $(document).on('click', el.button, function () {
      const target = $(this).data("target");
      $(el.button).removeClass('active')
      $(this).addClass('active')
      $(el.tabContent).attr("open", false);
      $(`#${target}`).attr("open", true);
    })
  })

};

try {
  slider();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("Error:", error);
}
